<template>
  <div class="w-64">
    <canvas
      :id="chartId"
      class="px-0.5 py-0"
    />
    <div class="text-xs text-gray-400 text-center">
      {{ title }}
    </div>
  </div>
</template>
<script>
import { createProp } from '@/composables/create-prop'
import Chart from 'chart.js'

export default {
  props: {
    title: createProp(String),
    icon: createProp(String),
    data: createProp(Array),
    labels: createProp(Array),
    colors: createProp(Array),
    chartId: createProp(String)
  },
  data () {
    return {
      chartData: {
        type: 'doughnut',
        data: {
          labels: ['S', 'S', 'M', 'T', 'W ', 'T', 'F'],
          datasets: [
            {
              data: [0, 10, 20, 30, 50, 40, 90],
              borderColor: '#ccc',
              borderWidth: 0.5
            }
          ]
        },
        options: {
          elements: {
            point: {
              radius: 2,
              hoverRadius: 2,
              backgroundColor: '#EC4899'
            },
            line: {
              fill: false,
              borderWidth: 10,
              tension: 0
            }
          },
          legend: {
            display: false,
            position: 'bottom'
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false
                },
                display: false,
                ticks: {
                  display: false // this will remove only the label
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  display: false // this will remove only the label
                }
              }
            ]
          }
        }
      }
    }
  },
  mounted () {
    this.createChart(this.chartId, this.chartData)
  },
  methods: {
    createChart (chartId, chartData) {
      this.chartData.data.labels = this.labels
      this.chartData.data.datasets[0].data = this.data
      this.chartData.data.datasets[0].backgroundColor = this.colors
      console.log(this.data)
      const ctx = document.getElementById(chartId).getContext('2d')
      // eslint-disable-next-line no-new
      new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      })
    }
  }
}
</script>
